import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";

import { round_to_1000 } from "../functions.ts";
import { useEffect } from "react";
import ModalConfirmButton from '../components/modal_close_button.tsx';

export default function ModalPhotovoltaikFuture() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    const financial_plan_dummy = useStore((state)=>state.financial_plan_dummy);

    const photovoltaik_future = useStore((state)=>state.photovoltaik_future);    
    const api_get_costs = useStore((state)=>state.api_get_costs);
    useEffect(()=>{
        api_get_costs("photovoltaics",photovoltaik_future);
    },[photovoltaik_future]);
        

  return (<Panel >
            <h1 id="modal-title">Welche Photovoltaik-Anlage ist geplant?</h1>
            <PropertyInput type="photovoltaik_future"/>
            <PropertyInput type="photovoltaik_kosten" placeholder_prefix={"optional ca."} placeholder_override={round_to_1000(financial_plan_dummy["photovoltaics"].total_costs)  + " €"}/>
            <PropertyInput type="photovoltaik_battery_storage_future"/>
            <PropertyInput type="stromverbrauch"/>
           <ModalConfirmButton  onClick={()=>{
                close_menu();
                init_property_if_undefined("photovoltaik_future");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}